export function UncheckedIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        stroke="black"
        strokeOpacity="0.5"
        strokeWidth="2"
      />
    </svg>
  )
}
